<script>
import { periodicTasksIntervalScheduleMethods } from '@state/helpers'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'IntervalScheduleForm',
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      action: 'create',
      form: {
        url: null,
        every: null,
        period: null,
      },
    }
  },
  validations: {
    form: {
      every: {
        required,
      },
      period: {
        required,
      },
    },
  },
  computed: {},

  mounted: function () {
    let context = this
    if (context.instanceJson.url) {
      context.action = 'update'
      context.form = {
        ...context.instanceJson,
      }
      context.getObject()
    } else {
      context.action = 'create'
      context.loading = false
    }
  },

  methods: {
    ...periodicTasksIntervalScheduleMethods,

    getObject() {
      let context = this
      if (context.action == 'update') {
        const promise = context.fetchPeriodicTasksIntervalScheduleDetail(
          context.form.url
        )
        return promise
          .then((data) => {
            context.form = { ...data }
            context.loading = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.loading = false
          })
      }
    },

    submit() {
      let context = this
      context.submitting = true
      context.$v.form.$touch()
      if (context.$v.form.$invalid) {
        context.$generate_toast(
          context,
          'error',
          'Por favor llene todos los campos requeridos'
        )
        return
      }
      const promise = context.createUpdatePeriodicTasksIntervalSchedule(
        context.form
      )
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `Intervalo ${
              context.action == 'create' ? 'creado' : 'actualizado'
            } correctamente`
          )
          setTimeout(() => {
            context.oncomplete(data.url)
            context.submitting = false
          }, 3000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="action === 'create' ? 'Crear Intervalo' : 'Editar Intervalo'"
    :size="action === 'create' ? 'md' : 'md'"
    @hidden="oncancel"
    @ok.prevent="submit"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <b-form id="form">
            <form-wrapper :validator="$v.form">
              <div>
                <form-summary />
              </div>
              <b-row>
                <b-col md="6">
                  <form-group
                    name="every"
                    label="Ejecutar cada"
                    attribute="Ejecutar cada"
                  >
                    <b-form-input
                      v-model="form.every"
                      type="number"
                      min="1"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                </b-col>
                <b-col md="6">
                  <form-group name="period" label="Período" attribute="Período">
                    <b-form-select
                      v-model="form.period"
                      :options="[
                        { value: 'days', text: 'Días' },
                        { value: 'hours', text: 'Horas' },
                        { value: 'minutes', text: 'Minutos' },
                        { value: 'seconds', text: 'Segundos' },
                        { value: 'microseconds', text: 'Microsegundos' },
                      ]"
                    ></b-form-select>
                  </form-group>
                </b-col>
              </b-row>
            </form-wrapper>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" @click="cancel">
        Cancelar
      </b-button>

      <b-button
        size="sm"
        variant="primary"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> Guardando </span>
        <span v-else>
          <i class="fe-save"></i>
          Guardar
        </span>
      </b-button>
    </template>
  </b-modal>
</template>
<style lang="scss">
</style>